module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section o-section__max-w--narrow o-section__max-w o-section--pt c-loading-section",
    class: {
      'c-loading-section--loaded': _vm.productLoaded, 'c-product--loaded': _vm.swiperLoaded
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column c-column--rows"
  }, [_c('h1', {
    staticClass: "c-product__header"
  }, [_vm._v(_vm._s(_vm.ring.name))]), _vm._v(" "), _c('h3', {
    staticClass: "c-product__description"
  }, [_vm._v("\"" + _vm._s(_vm.ring.description) + "\"")]), _vm._v(" "), _c('span', {
    staticClass: "c-product__accordion"
  }, [_c('span', {
    staticClass: "c-accordion c-accordion--tiny"
  }, [_c('h2', {
    staticClass: "c-accordion__header",
    on: {
      "click": function($event) {
        _vm.toggleAccordion($event)
      }
    }
  }, [_vm._v("More detail")]), _vm._v(" "), _c('div', {
    staticClass: "c-accordion__content"
  }, [_c('h4', {
    staticClass: "c-product__detail"
  }, [_vm._v(_vm._s(_vm.ring.detail))])])])]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.swiperLoaded),
      expression: "swiperLoaded"
    }],
    staticClass: "u-desktop-only c-btn c-btn__link c-btn__link--relative v-fade",
    staticStyle: {
      "bottom": "0",
      "left": "0",
      "display": "inline-table"
    },
    attrs: {
      "to": "/shop"
    }
  }, [_vm._v("Back to shop")])], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "c-product__images"
  }, [_c('div', {
    staticClass: "js-slider-for c-product__mainImage"
  }, _vm._l((_vm.ring.variations[_vm.ring.variationIndex].images), function(image, index) {
    return _c('span', {
      key: image.index,
      staticClass: "c-product__mainImages",
      style: ({
        'background-image': 'url(' + image.url + ')'
      })
    })
  })), _vm._v(" "), _c('span', {
    staticClass: "c-loading-block c-loading-block--up",
    staticStyle: {
      "height": "500px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-product__carouselImages js-slider-nav"
  }, _vm._l((_vm.ring.variations[_vm.ring.variationIndex].images), function(image, index) {
    return _c('span', {
      key: image.index,
      staticClass: "c-product__carouselImage",
      class: {
        'c-product__carouselImage--active': _vm.carouselIndex == index
      },
      on: {
        "click": function($event) {
          _vm.changeSlide(index)
        }
      }
    }, [_c('img', {
      attrs: {
        "width": "80",
        "height": "80",
        "src": image.url,
        "alt": "Signet ring - thumbnail"
      }
    })])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column c-column--rows c-product"
  }, [_c('span', {
    staticClass: "c-product--anim c-product--anim1",
    staticStyle: {
      "z-index": "3"
    }
  }, [_c('div', {
    staticClass: "c-field c-field--abnormal"
  }, [_c('v-select', {
    attrs: {
      "label": "variation_name",
      "value": "variation_name",
      "clearable": false,
      "options": _vm.ring.variations
    },
    model: {
      value: (_vm.variation),
      callback: function($$v) {
        _vm.variation = $$v
      },
      expression: "variation"
    }
  })], 1)]), _vm._v(" "), _c('span', {
    staticClass: "c-product--anim c-product--anim2",
    staticStyle: {
      "z-index": "2"
    }
  }, [_c('div', {
    staticClass: "c-field"
  }, [_c('v-select', {
    attrs: {
      "label": "text",
      "value": "value",
      "clearable": false,
      "options": _vm.sizes
    },
    model: {
      value: (_vm.size),
      callback: function($$v) {
        _vm.size = $$v
      },
      expression: "size"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "c-btn__link c-btn__link--dropdown",
    staticStyle: {
      "z-index": "1"
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        _vm.openSizeGuide($event)
      }
    }
  }, [_vm._v("SIZE GUIDE")])], 1)]), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "c-product__price c-product--anim c-product--anim4",
    staticStyle: {
      "z-index": "1"
    }
  }, [_c('span', {
    staticClass: "c-cart__subTotal-currency"
  }, [_vm._v(_vm._s(_vm.ring.variations[_vm.ring.variationIndex].price[_vm.$store.state.currency].currency))]), _vm._v(" "), _c('span', {
    staticClass: "c-product__price"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.currency != 'EUR' && _vm.$store.state.currency != 'GBP'),
      expression: "$store.state.currency != 'EUR' && $store.state.currency != 'GBP'"
    }]
  }, [_vm._v("$")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.currency == 'EUR'),
      expression: "$store.state.currency == 'EUR'"
    }]
  }, [_vm._v("€")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.currency == 'GBP'),
      expression: "$store.state.currency == 'GBP'"
    }]
  }, [_vm._v("£")]), _vm._v("\n            " + _vm._s(_vm.price) + "\n          ")])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "c-product__aside c-product--anim c-product--anim5",
    staticStyle: {
      "z-index": "1"
    }
  }, [_vm._v(_vm._s(_vm.ring.name) + " is made to order. It may take up to 4 weeks to ship.")]), _vm._v(" "), _c('div', {
    staticClass: "c-product--anim c-product--anim6",
    staticStyle: {
      "z-index": "1",
      "width": "100%"
    }
  }, [_c('a', {
    staticClass: "c-btn--block",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        _vm.addToCart($event)
      }
    }
  }, [_vm._v("Add to cart")])]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.swiperLoaded),
      expression: "swiperLoaded"
    }],
    staticClass: "u-mobile-only c-btn c-btn__link c-btn__link--shop c-btn__link--relative v-fade",
    staticStyle: {
      "bottom": "0",
      "left": "0",
      "position": "relative",
      "display": "inline-table"
    },
    attrs: {
      "to": "/shop"
    }
  }, [_vm._v("Back to shop")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-710cc04b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Product.vue
// module id = 399
// module chunks = 0